import { useState } from 'react';
export function useDossierFilters(initialFilters) {
    const [filters, setFilters] = useState(initialFilters);
    // eslint-disable-next-line
    function setFilter(filter) {
        return (name, val) => {
            return setFilters(currentFilters => ({
                ...currentFilters,
                [name]: val,
            }));
        };
    }
    const [previousFilters, setPreviousFilters] = useState(initialFilters);
    return {
        filters,
        setFilter,
        setFilters,
        previousFilters,
        setPreviousFilters,
    };
}
